export default __webpack_public_path__ + "static/media/j1.06990a70.jpeg";